export function splitPresentationTitle(fullTitle: string): { part1: string; part2: string } {
  const separators = [
    { char: ":", keepWithPart1: true },
    { char: " - ", keepWithPart1: false },
    { char: " – ", keepWithPart1: false },
    { char: " — ", keepWithPart1: false },
  ];

  for (const sep of separators) {
    const index = fullTitle.indexOf(sep.char);
    if (index !== -1) {
      const cutPoint = sep.keepWithPart1 ? index + sep.char.length : index;
      const part1 = fullTitle.slice(0, cutPoint).trim();
      const part2 = fullTitle.slice(index + sep.char.length).trim();
      return { part1, part2 };
    }
  }

  // Kein Trenner gefunden -> Titel ggf. nach Wortzahl aufteilen
  const words = fullTitle.trim().split(/\s+/);
  if (words.length > 7) {
    return {
      part1: words.slice(0, 7).join(" "),
      part2: words.slice(7).join(" "),
    };
  }

  return { part1: fullTitle.trim(), part2: "" };
}